import React from 'react'

export const FxaPrompt = ({ dict }) => {
  return (
    <div className="fxa-container coreform-container loginform-container">
      <h2>{dict.fxaCalltoaction}</h2>
      <p>{dict.fxaWannaproceed}</p>
      <form action="/fxa_upgrade_process" id="fxa-upgrade-form" method="post">
        <div>
          <label htmlFor="fxaYes">
            <input
              type="radio"
              name="fxa-migrate"
              value="yes"
              id="fxaYes"
              defaultChecked
            />
            <div className="label-helper-text">
              <div className="label-header">{dict.fxaYeslabel}</div>
              <div className="label-body">{dict.fxaYestext}</div>
            </div>
          </label>
        </div>
        <div className="fxa-divider" />
        <div>
          <label htmlFor="fxaNo">
            <input type="radio" name="fxa-migrate" value="no" id="fxaNo" />
            <div className="label-helper-text">
              <div className="label-header">{dict.fxaNolabel}</div>
              <div className="label-body">{dict.fxaNotext}</div>
            </div>
          </label>
        </div>
        <div className="fxa-footer">
          <button className="login-btn-email">{dict.fxaConfirm}</button>
        </div>
      </form>
    </div>
  )
}
